import { createSlice } from "@reduxjs/toolkit"; 
import  { CommissionType } from '../../models/commission.interface'


const initialState: CommissionState = {
  totalProfit: 0,
  userCommissions: [],
}

export const commissionSlice = createSlice({
  name: 'commission',
  initialState,
  reducers: {
    fetchUserCommission: (state) => {}, // saga
    setUserCommission: (state: any, action) => {
      const { totalProfit, userCommissions } = action.payload
      state.totalProfit = totalProfit
      state.userCommissions = userCommissions
    },
    withdrawCommission: (state, action) => {}, //saga
  }
})

export const { 
  fetchUserCommission, 
  setUserCommission,
  withdrawCommission,
} = commissionSlice.actions
export const { name, actions, reducer } = commissionSlice
export default commissionSlice.reducer